/**
 * Recursos humanos (WALLIYO-0131), en español. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrEs = {
  "hr.tabs.aria": "Recursos humanos",
  "hr.tab.directory": "Directorio",
  "hr.tab.recruiting": "Selección",
  "hr.tab.employees": "Empleados",
  "hr.tab.learning": "Formación",
  "hr.subTabs.aria": "Empleados",
  "hr.sub.records": "Expedientes",
  "hr.sub.joining": "Incorporación",
  "hr.sub.timeOff": "Vacaciones de todos",
  "hr.sub.performance": "Desempeño",
  "hr.sub.payroll": "Nómina",
  "hr.sub.reviews": "Revisiones",
  "hr.sub.leaving": "Salidas",
  "hr.locked": "Esta pestaña es para recursos humanos.",
  "hr.notBuilt": "Todavía no está construido.",
  "hr.notBuiltHelp": "Esta pestaña está diseñada y espera su punto de acceso. No se pierde nada.",
  "directory.title": "Directorio",
  "directory.sub": "Cualquiera puede buscar a cualquiera.",
  "directory.search": "Buscar a alguien",
  "directory.searchHelp": "Un nombre, o el número de su credencial.",
  "directory.searchPlaceholder": "Nombre o UUID",
  "directory.go": "Buscar",
  "directory.clear": "Ver a todos",
  "directory.loading": "Leyendo el directorio…",
  "directory.failed": "No se pudo leer el directorio.",
  "directory.retry": "Reintentar",
  "directory.none": "Nadie aquí coincide con «{query}».",
  "directory.empty": "Todavía no hay nadie en la lista.",
  "directory.count": "{shown} de {total}",
  "directory.more": "Hay más coincidencias de las mostradas. Afina la búsqueda.",
  "directory.colName": "Nombre",
  "directory.colRoles": "Rol",
  "directory.colTeams": "Equipos",
  "directory.colManager": "Responsable",
  "directory.open": "Abrir",
  "directory.noRole": "Todavía sin rol",
  "directory.noTeam": "Todavía sin equipo",
  "directory.noManager": "Sin responsable",
  "directory.leads": "lo dirige",
  "directory.invited": "Invitado",
  "directory.back": "Volver al directorio",
  "directory.identity": "Quién es",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "El número de su credencial. Nunca cambia.",
  "directory.email": "Correo",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Todos en sus equipos",
  "directory.whereTheySit": "Dónde se sitúa",
  "directory.emailThem": "Enviar un correo",
  "directory.teammatesNone": "Es la única persona en sus equipos.",
  "directory.personFailed": "No se pudo leer a esta persona.",
  "directory.viewOnly": "El directorio muestra solo la estructura. Lo que alguien puede hacer está en Empleados.",
  "hr.loading": "Leyendo…",
  "hr.failed": "No se pudo leer eso.",
  "hr.retry": "Reintentar",
  "joining.invite": "Invitar a alguien",
  "joining.invited.title": "Invitaciones pendientes",
  "joining.invited.help": "Ya tienen un UUID y no pueden entrar hasta que fijen una contraseña.",
  "joining.invited.none": "Nadie está esperando para llegar.",
  "joining.arrived.title": "Llegaron hace poco",
  "joining.arrived.help": "Todos los que se incorporaron en los últimos 30 días.",
  "joining.arrived.none": "Nadie se ha incorporado en los últimos 30 días.",
  "joining.col.name": "Nombre",
  "joining.col.roles": "Rol",
  "joining.col.sent": "Invitado el",
  "joining.col.waiting": "Esperando",
  "joining.col.joined": "Se incorporó el",
  "joining.today": "Hoy",
  "joining.waiting": "{days} días",
  "joining.stale": "Conviene insistir",

  // ── Leaving ──
  "leaving.who": "Quién se va",
  "leaving.whoHelp": "Todos los que siguen aquí, y los que ya se han ido.",
  "leaving.pick": "Elegir a alguien",
  "leaving.alreadyLeft": "ya se fue",
  "leaving.nobody": "Elige a alguien para ver qué dejaría atrás su salida.",
  "leaving.gone": "{name} ya se ha ido. Esto es lo que quedó suelto.",
  "leaving.noReason": "No se dio ningún motivo",
  "leaving.teams.title": "Equipos que dirige",
  "leaving.teams.help":
    "En un equipo sin responsable nadie aprueba vacaciones, nadie revisa a nadie y nadie da fe de los accesos: es el mismo hecho.",
  "leaving.teams.none": "No dirige ningún equipo.",
  "leaving.teams.col.team": "Equipo",
  "leaving.teams.col.others": "Otras personas",
  "leaving.teams.col.after": "Tras su salida",
  "leaving.team.others": "{count} más",
  "leaving.team.noLead": "Nadie lo dirigiría",
  "leaving.team.covered": "Otra persona lo dirige",
  "leaving.team.handOver": "Traspasar",
  "leaving.grants.title": "Concedido a su nombre",
  "leaving.grants.help":
    "Quitar un rol nunca toca esto. Una concesión sin fecha de fin es como alguien que se fue sigue con un permiso.",
  "leaving.grants.none": "No se le concedió nada a su nombre.",
  "leaving.grants.col.what": "Qué",
  "leaving.grants.col.why": "Por qué",
  "leaving.grants.col.ends": "Termina",
  "leaving.grant.forever": "No termina nunca",
  "leaving.grant.until": "Hasta",
  "leaving.grants.revoke": "Retirar estos",
  "leaving.last.title": "El último paso",
  "leaving.last.help":
    "Desactivar cierra sus {sessions} sesiones abiertas y le impide entrar. Nada de lo que hizo se borra —la auditoría lo nombra para siempre— y sigue listado en sus equipos, para que nadie se quede discretamente sin una persona.",
  "leaving.last.deactivate": "Desactivar",
  "leaving.last.seeThem": "Verlo en el directorio",

  // ── Records ──
  "records.find": "Buscar",
  "records.findPlaceholder": "Nombre o correo",
  "records.team": "Equipo",
  "records.role": "Rol",
  "records.any": "Todos",
  "records.dueReview": "{count} accesos por revisar",
  "records.accessDueReview": "acceso por revisar",
  "records.none": "Nadie coincide.",
  "records.neverSeen": "Nunca ha entrado",
  "records.col.person": "Persona",
  "records.col.role": "Rol",
  "records.col.teams": "Equipos",
  "records.col.joined": "Se incorporó",
  "records.col.lastSeen": "Visto por última vez",

  // ── Time off ──
  "timeOff.ask": "Pedir vacaciones",
  "timeOff.approve": "Aprobar",
  "timeOff.refuse": "Rechazar",
  "timeOff.days": "{days} días",
  "timeOff.decidedBy": "Decidido por {name}",
  "timeOff.col.who": "Quién",
  "timeOff.col.kind": "Tipo",
  "timeOff.col.when": "Cuándo",
  "timeOff.col.days": "Días",
  "timeOff.col.status": "Estado",
  "timeOff.kind.annual": "Vacaciones anuales",
  "timeOff.kind.sick": "Baja por enfermedad",
  "timeOff.kind.unpaid": "Sin sueldo",
  "timeOff.kind.parental": "Permiso parental",
  "timeOff.kind.other": "Otro",
  "timeOff.status.pending": "Esperando",
  "timeOff.status.approved": "Aprobado",
  "timeOff.status.refused": "Rechazado",
  "timeOff.status.withdrawn": "Retirado",
  "timeOff.balance.title": "Tu saldo",
  "timeOff.balance.none": "Todavía nadie ha fijado tu derecho. Recursos humanos lo hace en tu expediente laboral.",
  "timeOff.balance.allowance": "Derecho",
  "timeOff.balance.taken": "Disfrutado",
  "timeOff.balance.pending": "Solicitado",
  "timeOff.balance.pendingHelp": "Ni disfrutado ni libre.",
  "timeOff.balance.left": "Restante",
  "timeOff.toDecide.title": "Esperándote",
  "timeOff.toDecide.help": "Diriges su equipo, así que te toca decidir. Estar en recursos humanos no es lo mismo.",
  "timeOff.mine.title": "Tus solicitudes",
  "timeOff.mine.none": "No has pedido vacaciones.",
  "timeOff.away.title": "Ausentes hoy",
  "timeOff.away.none": "Hoy no falta nadie.",
  "timeOff.everybody.title": "De todos",
  "timeOff.everybody.help": "Ves esto porque estás en recursos humanos. Decide el responsable de su equipo.",
  "timeOff.form.title": "Pedir vacaciones",
  "timeOff.form.kind": "Tipo",
  "timeOff.form.from": "Primer día",
  "timeOff.form.to": "Último día",
  "timeOff.form.days": "Días",
  "timeOff.form.daysHelp": "Cuántos días laborables cubre.",
  "timeOff.form.reason": "Motivo",
  "timeOff.form.submit": "Enviar la solicitud",
  "timeOff.decide.title": "Decidir esta solicitud",
  "timeOff.decide.approveNote": "Di por qué la apruebas",
  "timeOff.decide.refuseNote": "Di por qué la rechazas",
  "timeOff.decide.submit": "Registrar la decisión",
  "timeOff.done": "{days} días solicitados. Lo decide quien dirige tu equipo.",
  "timeOff.approvedDone": "Las vacaciones de {name} están aprobadas.",
  "timeOff.refusedDone": "La solicitud de {name} ha sido rechazada.",

  // ── Reviews ──
  "reviews.grants.title": "Merece un vistazo ahora",
  "reviews.grants.help":
    "Una concesión con fecha de fin se retira sola. Estas son las que no, y las de quien ya no está.",
  "reviews.grants.none": "No hay nada concedido a nombre propio sin fecha de fin.",
  "reviews.leads.title": "Responsables que deben revisar a su gente",
  "reviews.leads.help": "Quién dirige su equipo ya lo sabemos: nadie necesita que le digan quién revisa a quién.",
  "reviews.leads.none": "Nadie en los equipos tiene nada concedido a su nombre.",
  "reviews.col.who": "Quién",
  "reviews.col.what": "Qué",
  "reviews.col.why": "Por qué",
  "reviews.col.concern": "Problema",
  "reviews.col.lead": "Responsable",
  "reviews.col.team": "Equipo",
  "reviews.col.people": "Personas",
  "reviews.col.neverEnding": "Sin fin",
  "reviews.concern.holderLeft": "Se ha ido",
  "reviews.concern.neverEnds": "No termina nunca",
  "reviews.concern.neverUsed": "Nunca usado",
  "reviews.changedAt": "Cambiado el {when}",
  "reviews.open": "Abrir sus permisos",

  // ── Payroll ──
  "payroll.month": "Mes",
  "payroll.open": "Abrir un mes",
  "payroll.close": "Cerrar el mes",
  "payroll.notOpen": "Este mes todavía no se ha abierto.",
  "payroll.closedOn": "Cerrado el {when} por {name}",
  "payroll.hold": "Retener",
  "payroll.release": "Liberar",
  "payroll.lines.title": "Lo que cobra cada persona",
  "payroll.lines.help":
    "Trazado a partir de los expedientes laborales tal como estaban al abrir el mes. Una subida posterior no cambia lo de aquí.",
  "payroll.col.person": "Persona",
  "payroll.col.gross": "Bruto",
  "payroll.col.contributions": "Cotizaciones",
  "payroll.col.net": "Neto",
  "payroll.col.status": "Estado",
  "payroll.status.ready": "Listo",
  "payroll.status.held": "Retenido",
  "payroll.status.paid": "Pagado",
  "payroll.total.people": "Personas",
  "payroll.total.gross": "Bruto",
  "payroll.total.contributions": "Cotizaciones",
  "payroll.total.net": "Neto",
  "payroll.missing.title": "Nadie sabe lo que ganan estas personas",
  "payroll.missing.help":
    "Su expediente laboral no tiene bruto, así que una nómina no puede pagarles. Anótalo antes del próximo mes.",
  "payroll.openForm.title": "Abrir un mes",
  "payroll.openForm.month": "Mes",
  "payroll.openForm.help":
    "Cada expediente con un bruto recibe una línea. Las cotizaciones empiezan en cero: lo que se retiene depende de dónde esté cada quien, y no le toca a esta pantalla adivinarlo.",
  "payroll.openForm.submit": "Abrir",
  "payroll.holdForm.title": "Cambiar esta línea",
  "payroll.holdForm.hold": "Retenerla",
  "payroll.holdForm.release": "Liberarla",
  "payroll.closeForm.title": "Cerrar el mes",
  "payroll.closeForm.help": "Cada línea lista pasa a pagada. Una retenida sigue retenida, que para eso se retuvo.",
  "payroll.closeForm.submit": "Cerrar",
  "payroll.opened": "{month} está abierto, con {count} líneas.",
  "payroll.held": "La línea de {name} está retenida.",
  "payroll.released": "La línea de {name} se pagará.",
  "payroll.closed": "El mes está cerrado.",

  // ── Performance ──
  "performance.cycle": "Ciclo",
  "performance.openCycle": "Abrir un ciclo",
  "performance.noCycle": "Todavía no se ha abierto ningún ciclo.",
  "performance.runs": "Del {from} al {to}",
  "performance.write": "Escribir",
  "performance.keepWriting": "Seguir escribiendo",
  "performance.col.who": "Quién",
  "performance.col.reviewer": "Evaluador",
  "performance.col.status": "Estado",
  "performance.col.outcome": "Cómo fue",
  "performance.status.notStarted": "Sin empezar",
  "performance.status.inProgress": "Escribiéndose",
  "performance.status.submitted": "Enviada",
  "performance.status.signedOff": "Validada",
  "performance.gap.noTeam": "En ningún equipo",
  "performance.gap.noLead": "El equipo no tiene responsable",
  "performance.gap.leadsOwn": "Dirige su propio equipo",
  "performance.toWrite.title": "Esperándote",
  "performance.toWrite.help": "Diriges su equipo, así que te toca escribirla.",
  "performance.mine.title": "Tu evaluación",
  "performance.mine.none": "No tienes evaluación en este ciclo.",
  "performance.everybody.title": "De todos",
  "performance.everybody.help": "Ves esto porque estás en recursos humanos. Escribirla le toca al evaluador.",
  "performance.everybody.gaps":
    "{count} de estas no tienen quién las escriba. Eso habla de la organización, no de este ciclo.",
  "performance.form.title": "Abrir un ciclo",
  "performance.form.name": "Nombre",
  "performance.form.opens": "Primer día",
  "performance.form.closes": "Último día",
  "performance.form.submit": "Abrir",
  "performance.writeForm.title": "Escribir la evaluación",
  "performance.writeForm.outcome": "Cómo fue",
  "performance.writeForm.outcomeHelp": "Una palabra que eliges, no una nota sobre cinco.",
  "performance.writeForm.note": "Qué pasó",
  "performance.writeForm.save": "Guardar para después",
  "performance.writeForm.send": "Enviar",
  "performance.opened": "{name} está abierto, con {count} evaluaciones.",
  "performance.saved": "Guardado. Nadie lo ve hasta que lo envíes.",
  "performance.sent": "Enviado. {name} ya puede verlo.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Abrir una vacante",
  "recruiting.editJob": "Editar",
  "recruiting.addCandidate": "Añadir a alguien",
  "recruiting.move": "Avanzar",
  "recruiting.none": "Todavía no se ha abierto ninguna vacante.",
  "recruiting.noTeam": "Sin equipo",
  "recruiting.noCandidates": "Todavía no se ha presentado nadie.",
  "recruiting.liveCandidates": "{count} en juego",
  "recruiting.col.candidate": "Candidato",
  "recruiting.col.reach": "Cómo contactarle",
  "recruiting.col.stage": "Etapa",
  "recruiting.col.applied": "Se presentó",
  "recruiting.stage.applied": "Se presentó",
  "recruiting.stage.screening": "Preselección",
  "recruiting.stage.interview": "Entrevista",
  "recruiting.stage.offer": "Oferta enviada",
  "recruiting.stage.hired": "Contratado",
  "recruiting.stage.declined": "Rechazado",
  "recruiting.stage.withdrawn": "Se retiró",
  "recruiting.status.open": "Abierta",
  "recruiting.status.onHold": "En pausa",
  "recruiting.status.filled": "Cubierta",
  "recruiting.status.closed": "Cerrada",
  "recruiting.jobForm.title": "Abrir una vacante",
  "recruiting.jobForm.name": "Título",
  "recruiting.jobForm.team": "Equipo",
  "recruiting.jobForm.noTeam": "Todavía sin equipo",
  "recruiting.jobForm.description": "En qué consiste",
  "recruiting.jobForm.status": "Estado",
  "recruiting.jobForm.submit": "Abrir",
  "recruiting.candidateForm.title": "Añadir a alguien",
  "recruiting.candidateForm.name": "Nombre",
  "recruiting.candidateForm.phone": "Teléfono",
  "recruiting.candidateForm.email": "Correo",
  "recruiting.candidateForm.note": "Lo que conviene saber",
  "recruiting.candidateForm.submit": "Añadir",
  "recruiting.moveForm.title": "Avanzar",
  "recruiting.moveForm.stage": "Etapa",
  "recruiting.moveForm.hired":
    "Marcar a alguien como contratado registra que lo fue. Invitarle se hace en Incorporación, donde ya existe.",
  "recruiting.moveForm.submit": "Avanzar",
  "recruiting.jobOpened": "{title} está abierta.",
  "recruiting.jobEdited": "{title} se ha actualizado.",
  "recruiting.candidateAdded": "{name} está en la lista.",
  "recruiting.candidateMoved": "{name} está ahora en {stage}.",
  "learning.addCourse": "Añadir un curso",
  "learning.enrol": "Inscribirse",
  "learning.continue": "Seguir",
  "learning.finish": "Terminar",
  "learning.alreadyEnrolled": "Inscrito",
  "learning.requiredBy": "Exigido por {permission}: termínalo antes de la concesión, no después.",
  "learning.requiredOfAll": "Obligatorio para todos",
  "learning.anybody": "Abierto a todos",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} inscritos",
  "learning.hrOnly": "Solo recursos humanos",
  "learning.mine.title": "Obligatorio para ti",
  "learning.mine.help": "Un curso ligado a un permiso debe terminarse antes de que se conceda el permiso.",
  "learning.mine.none": "Ahora mismo no hay nada obligatorio para ti.",
  "learning.catalogue.title": "Catálogo",
  "learning.catalogue.help":
    "Abierto a todos. Inscribirse no necesita el permiso de nadie: lo necesita la concesión que hay detrás del curso.",
  "learning.byTeam.title": "En toda la empresa",
  "learning.byTeam.help": "Quién debe todavía los cursos obligatorios. De insistir se encarga quien dirige el equipo.",
  "learning.col.course": "Curso",
  "learning.col.status": "Estado",
  "learning.col.progress": "Progreso",
  "learning.col.team": "Equipo",
  "learning.col.people": "Personas",
  "learning.col.done": "Hecho",
  "learning.status.enrolled": "Inscrito",
  "learning.status.inProgress": "En marcha",
  "learning.status.done": "Terminado",
  "learning.courseForm.title": "Añadir un curso",
  "learning.courseForm.name": "Título",
  "learning.courseForm.audience": "Para quién",
  "learning.courseForm.minutes": "Cuánto dura, en minutos",
  "learning.courseForm.required": "Exigido por un permiso",
  "learning.courseForm.requiredHelp": "El id de ajuste del permiso del que este curso es condición.",
  "learning.courseForm.everybody": "Obligatorio para todos",
  "learning.courseForm.submit": "Añadir",
  "learning.courseAdded": "{title} está en el catálogo.",
  "learning.enrolledDone": "Inscrito en {title}.",
  "learning.finished": "{title} está terminado.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Cerrar",
  "error.reason.permission_not_held":
    "Tu rol abre esta pantalla, pero no esta acción. Pídeselo a alguien que pueda concederla.",
  "error.reason.not_found": "Esto ya no existe. Recarga y vuelve a intentarlo.",
  "error.reason.no_reason": "Di por qué, en pocas palabras.",
  "error.reason.name_taken": "Ese nombre ya está ocupado.",
  "error.reason.team_closed": "Esto está cerrado. Vuelve a abrirlo antes de añadir a nadie.",
  "error.reason.staff_deactivated": "Esta persona se ha ido y no puede añadirse.",
  "error.reason.lead_must_be_member": "Solo se dirige un equipo del que se forma parte.",
  "error.reason.duplicate_change": "La misma persona aparece dos veces. Envíala una sola vez.",
  "error.reason.own_request": "No puedes decidir tus propias vacaciones.",
  "error.reason.not_their_lead":
    "Solo quien dirige su equipo puede decidirlo. Estar en recursos humanos no es lo mismo.",
  "error.reason.already_decided": "Esto ya está decidido. Recarga para ver cómo.",
  "error.reason.backwards": "El último día es anterior al primero.",
  "error.reason.too_long": "Eso es más largo de lo que una solicitud puede cubrir.",
  "error.reason.month_open": "Ese mes ya está abierto.",
  "error.reason.already_paid": "Esta línea se ha pagado. Un mes cerrado es lo que se pagó.",
  "error.reason.already_closed": "Este mes ya está cerrado.",
  "error.reason.nobody_payable": "Ningún expediente laboral tiene un bruto anotado.",
  "error.reason.invalid_month": "Indica el mes como AAAA-MM.",
  "error.reason.own_review": "No puedes escribir tu propia evaluación.",
  "error.reason.not_the_reviewer": "Se le pidió a otra persona que la escribiera.",
  "error.reason.signed_off": "Esta evaluación está validada.",
  "error.reason.no_outcome": "Di cómo fue antes de enviarla.",
  "error.reason.job_closed": "Esta vacante está cerrada. Vuelve a abrirla antes de añadir a nadie.",
  "error.reason.candidate_out": "Esta persona ya no está en juego. Añádela de nuevo si vuelve.",
  "error.reason.title_taken": "Ese título ya está ocupado.",
  "error.reason.course_retired": "Este curso ya no se imparte.",
  "error.reason.invalid_progress": "El progreso es un porcentaje entero, de 0 a 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Todo",
  "roles.covers.features": "{count} funciones",
  "roles.covers.permissions": "{count} permisos",
  "roles.covers.critical": "{count} críticas",
  "roles.covers.high": "{count} altas",
  "roles.covers.seeAll": "Ver las {count}",
  "roles.covers.permissionsHeading": "Permisos",

  // ── Roles, redesigned ──
  "roles.band.critical": "roles pueden decidir lo que puede hacer cualquiera",
  "roles.band.people": "personas tienen uno de ellos",
  "roles.band.total": "roles en total",
  "roles.band.unheld": "no los tiene nadie",
  "roles.reach.critical": "Crítico",
  "roles.reach.high": "Alto",
  "roles.reach.low": "Bajo",
  "roles.rail.people": "{count} personas",
  "roles.rail.unheld": "no lo tiene nadie",
  "roles.noDescription": "Sin descripción",
  "roles.figure.people": "Personas",
  "roles.figure.features": "Funciones",
  "roles.figure.permissions": "Permisos",
  "roles.figure.critical": "Críticas",
  "roles.block.holders": "Quién lo tiene",
  "roles.block.holdersHelp": "Dar este rol a alguien le da todo lo de abajo.",
  "roles.block.holdersNone": "Nadie tiene este rol.",
  "roles.block.give": "Dárselo a alguien",
  "roles.block.take": "Quitarlo",
  "roles.block.grants": "Lo que concede",
  "roles.block.grantsHelp": "Hasta dónde llega, por área.",
  "roles.block.criticalWarning": "Quien tiene este rol puede decidir lo que puede hacer cualquier otro.",
  "roles.block.change": "Cambiar lo que concede",
  "roles.block.opens": "Lo que abre",
  "roles.block.opensHelp":
    "Calculado a partir de las funciones de arriba, nunca guardado: el menú usa la misma función.",
  "roles.block.opensNone": "No abre ninguna pantalla por sí solo.",
  "roles.block.compare": "Comparado con",
  "roles.block.compareWith": "Comparar con",
  "roles.compare.only": "{count} solo aquí",
  "roles.compare.theirs": "{count} solo allí",
  "roles.compare.shared": "{count} en común",
  "roles.give.title": "Dar este rol a alguien",
  "roles.give.who": "A quién",
  "roles.give.submit": "Dárselo",
  "roles.give.done": "{name} ya tiene {role}.",
  "roles.take.title": "Quitar este rol",
  "roles.take.body": "Conserva todos sus demás roles.",
  "roles.take.submit": "Quitarlo",
  "roles.take.done": "{name} ya no tiene {role}.",
  "roles.holdersUnknown": "No se pudo leer",
  "roles.compare.same": "Conceden exactamente las mismas funciones.",
  "roles.notice.critical":
    "{roles} de estos pueden decidir lo que puede hacer cualquiera: {people} personas tienen uno.",
  "roles.notice.criticalOnly": "{roles} de estos pueden decidir lo que puede hacer cualquiera.",
  "roles.notice.unheld": "{count} no lo tiene nadie.",

  // ── Actions, by person ──
  "actions.find": "Buscar a alguien",
  "actions.matches": "¿A quién te referías?",
  "actions.findPlaceholder": "Nombre o UUID",
  "actions.nobody": "Busca a alguien para ver lo que puede hacer.",
  "actions.noRoles": "Sin rol",
  "actions.col.on": "Activado",
  "actions.col.source": "Origen",
  "actions.col.reason": "Motivo",
  "actions.mustAsk": "debe pedir por encima de {limit}",
  "actions.clear": "Borrar",
  "actions.until": "hasta {when}",
  "actions.onlyOverrides":
    "Solo hay una excepción puesta en esta persona, así que es la única que esta pantalla puede quitar. Todo lo demás viene de un rol o de cómo se entrega la acción: cámbialos donde viven.",
  "actions.blocked.permission": "Tiene la función, no el permiso que exige esta acción.",
  "actions.locked.noFeature": "Abierta a todos: no hay interruptor detrás.",
  "actions.view.catalogue": "El catálogo",
  "actions.view.person": "Por persona",
  "actions.notWiredYet": "Activarlo todavía no está conectado. Usa Funciones y Permisos por ahora.",
  "actions.view.role": "Por rol",
  "actions.pickRole": "Rol",

  // ── Switching an action ──
  "actions.switch.onTitle": "Activar",
  "actions.switch.offTitle": "Desactivar",
  "actions.switch.clearTitle": "Borrar",
  "actions.switch.submit": "Activar",
  "actions.switch.writes": "Esto escribe la función que hay detrás: {feature}.",
  "actions.switch.alsoMoves": "Esa función también abre {count} acciones más, que se mueven con ella: {actions}.",
  "actions.switch.permissionToo": "Seguirá faltando el permiso que guarda esta acción. Concédelo en Permisos.",
  "actions.switch.switchedOn": "{action} está activada para {who}.",
  "actions.switch.switchedOff": "{action} está desactivada para {who}.",
  "actions.switch.cleared": "{action} vuelve a lo que hereda.",
  "actions.pending": "sin guardar",
  "actions.saved": "{count} interruptores guardados.",
} as const;
